import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import TermsDownload from './components/TermsDownload';
import HowToSchedule from './components/HowToSchedule';
import DigitalCTA from './components/DigitalCTA';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <TermsDownload />
      <HowToSchedule />
      <DigitalCTA />
      <Footer />
    </div>
  );
}

export default App;